import { render, staticRenderFns } from "./GameTeamSuitPicker.vue?vue&type=template&id=4c7b3a33&scoped=true&"
import script from "./GameTeamSuitPicker.vue?vue&type=script&lang=js&"
export * from "./GameTeamSuitPicker.vue?vue&type=script&lang=js&"
import style0 from "./GameTeamSuitPicker.vue?vue&type=style&index=0&id=4c7b3a33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7b3a33",
  null
  
)

export default component.exports